<template>
  <div class="home">
      <Doc class="marginal"></Doc>
  </div>
</template>

<script>
import Doc from '@/components/documentation/Doc.vue';
export default {
  name: 'DocPage',
  components: {
    Doc
  }
}
</script>